// extracted by mini-css-extract-plugin
export default {"wrapper":"ScreenButtons_wrapper__ORKgK"};